import { useEffect } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { Toaster } from 'sonner';
import { queryClient } from '@/core/config/queryClient';
import { AppRoutes } from '@/core/routes';
import { setApiTokenGetter } from '@/core/api/client';
import { useObservabilityIdentity } from '@/shared/observability/useObservabilityIdentity';
import { SupportMenuButton } from '@/shared/components/SupportMenuButton';
import { FontPrototypeSwitcher } from '@/shared/prototype/FontPrototypeSwitcher';
import { WorkspaceProvider } from '@/features/workspace-sub-delegation';
import { ConciergeChooserProvider } from '@/features/care-concierge/chooser/ConciergeChooserProvider';

export const App = () => {
  const { getToken } = useKindeAuth();

  useObservabilityIdentity();

  useEffect(() => {
    setApiTokenGetter(async () => {
      try {
        const token = await getToken();
        return token || null;
      } catch (error) {
        console.error('Failed to get Kinde token:', error);
        return null;
      }
    });
  }, [getToken]);

  return (
    <QueryClientProvider client={queryClient}>
      <WorkspaceProvider>
        {/* Feature 104: chooser + help button live inside providers so the
            help menu can role-gate and entry points share one dialog. */}
        <ConciergeChooserProvider>
          <AppRoutes />
          <SupportMenuButton />
        </ConciergeChooserProvider>
      </WorkspaceProvider>
      <Toaster position="top-right" richColors />
      {/* PROTOTYPE: font pairing switcher, dev + UAT only. Remove once a variant wins. */}
      <FontPrototypeSwitcher />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  );
};
